import { Component } from '@angular/core';
import { Optional, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';

interface ImagePreviewModel {
  images?: unknown[];
  index?: number;
}

@Component({
  selector: 'monorepo-image-preview',
  templateUrl: './image-preview.component.html',
  styleUrls: ['./image-preview.component.scss'],
})
export class ImagePreviewComponent {
  public galleryTopSwiperConfig: SwiperConfigInterface = {
    spaceBetween: 0,
    navigation: true,
    pagination: false,
  };
  imageList = [];
  index: number;

  constructor(
    public dialogRef: MatDialogRef<ImagePreviewComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: ImagePreviewModel
  ) {
    this.imageList = data.images;
    this.index = data.index;
  }

  public close(): void {
    this.index = null;
    this.dialogRef.close();
  }
}
